import { Button, makeStyles } from "@fluentui/react-components";
import { Link } from "react-router-dom";
import { useMobileStyles } from "./MobileStyles";

const useStyles = makeStyles({
    link: {
        textDecoration: "none",
        width: "100%",
    },
});

interface IMainMobileLink {
    path: string;
    text: string;
    onNavigate: () => void;
}

const MobileMainLink = (props: IMainMobileLink) => {
    const { path, text } = props;
    const styles = useStyles();
    const mobileStyles = useMobileStyles();

    return (
        <Link to={path} className={styles.link} onClick={props.onNavigate}>
            <Button as="a" appearance="subtle" className={mobileStyles.button}>
                {text}
            </Button>
        </Link>
    );
};

export default MobileMainLink;